import { render } from "./AlpacaImportPanel.vue?vue&type=template&id=a8de4636"
import script from "./AlpacaImportPanel.vue?vue&type=script&lang=js"
export * from "./AlpacaImportPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__